/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback } from "react";
import { GoogleReCaptcha, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import "../Login/login.css";

import { useTranslation } from "react-i18next";
import { Grid, Paper, Modal } from "@material-ui/core";
import { toast } from "react-toastify";
import { Form, Button } from "react-bootstrap";
import { userLogin } from "../../config/service";

import { otpSeconds } from "../../config/key";

import OtpModal from "./OtpModal";
export const handleKeyPress = (event) => {
  if (event.key === "+" || event.key === "-" || event.key === ".") {
    event.preventDefault();
  }
};

const ExistingUserLogin = ({ handleToggleAccount, formData, hasAccount, setHasAcoount }) => {
  const { t } = useTranslation();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [formValue, setformValue] = React.useState({
    id_number: "",
    mobile: "",
    password: "",
  });
  const [idError, setIdError] = useState("");
  const [mobileError, setmobileError] = useState("");
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(otpSeconds);
  const [isResendDisable, setIsResendDisable] = useState(true);
  const [channel, setChannel] = useState({
    channelName: "whatsapp",
    channelValue: false,
  });
  const [resendLoading, setResendLoading] = useState(false);
  const [, setRecaptchaToken] = useState("");
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const handleLogin = async (channelValue) => {
    const user = {
      phone: formValue.mobile,
      id: formValue.id_number,
      key: "client",
      channel: channelValue,
    };

    if (validate()) {
      setLoading(true);
      setResendLoading(true);
      try {
        const captchaToken = await executeRecaptcha("login");
        const customHeaders = {
          "x-recaptcha-token": captchaToken,
        };
        await userLogin(user, customHeaders);

        toast.success(t("An OTP sent to your mobile number"));
        setIsResendDisable(true);
        setOpen(true);
        setHasAcoount(false);
      } catch (error) {
        console.error(error);
        // Handle the error here, if needed
      } finally {
        setLoading(false);
        setResendLoading(false);
        setRefreshReCaptcha(!refreshReCaptcha);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(channel.channelName);
  };

  const handleResendOtp = async (value) => {
    await handleLogin(value);
    setSeconds(otpSeconds);
    setChannel((prev) => ({
      ...prev,
      channelName: value,
      channelValue: !prev.channelValue,
    }));
  };

  const handleUserConfirmationPhone = (e) => {
    const { name, value } = e.target;
    if (
      value.startsWith("+") &&
      !isNaN(value.substring(1, value.length)) &&
      !value.endsWith(".")
    ) {
      setformValue({
        ...formValue,
        [name]: value.trim(),
      });
    } else if (!isNaN(value) && !value.endsWith(".")) {
      setformValue({
        ...formValue,
        [name]: value,
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "id_number") {
      const valueUpperCase = value.toUpperCase();
      setformValue({
        ...formValue,
        [name]: valueUpperCase,
      });
    } else
      setformValue({
        ...formValue,
        [event.target.name]: event.target.value,
      });
  };
  const validate = () => {
    let isValid = true;

    if (!formValue.id_number) {
      isValid = false;
      setIdError(t("Please Enter Id Number"));
    } else {
      setIdError("");
    }
    if (!formValue.mobile) {
      isValid = false;

      setmobileError(t("Please enter your phone number"));
    }
    return isValid;
  };

  useEffect(() => {
    if (open) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 1) {
            clearInterval(timer);
            setIsResendDisable(false);
          }
          return prevSeconds - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [open, channel.channelValue]);

  const setTokenFunc = useCallback((getToken) => {
    setRecaptchaToken(getToken);
  }, []);
  useEffect(() => {
    if (!loading) {
      setRefreshReCaptcha(false);
    }
  }, [loading]);

  return (
    <div>
      <Modal
        open={hasAccount}
        onClose={handleToggleAccount}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ marginTop: "10%" }}
      >
        <Grid container direction="column" alignItems="center">
          <Grid item xs>
            <Paper className="paper" square>
              <div className={`auth-page  existing-auth `}>
                <div className="newRegd">
                  <div>
                    <div className="signTop">
                      <h2>{t("Connection")}</h2>
                    </div>
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="form-group ">
                        <Form.Control
                          name="id_number"
                          type="text"
                          onWheel={(e) => e.target.blur()}
                          onChange={handleChange}
                          id="id_input"
                          placeholder={t("ID Number")}
                          onKeyPress={handleKeyPress}
                          onInput={(e) => {
                            const regex = /^[a-zA-Z0-9]*$/;
                            if (!regex.test(e.target.value)) {
                              e.target.value = e.target.value.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );
                            }
                            e.target.value = e.target.value.slice(0, 14);
                          }}
                          autocomplete="off"
                        />
                      </Form.Group>
                      <span className="errorsmg">{t(`${idError}`)}</span>
                      <Form.Group className="form-group ">
                        <Form.Control
                          id="mobile_input"
                          type="text"
                          placeholder={t("Mobile Number")}
                          name="mobile"
                          onChange={handleUserConfirmationPhone}
                          value={formValue?.mobile ? formValue?.mobile : ""}
                          autocomplete="off"
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9+]/g,
                              ""
                            );
                          }}
                        />
                      </Form.Group>
                      <span className="errorsmg">{t(`${mobileError}`)}</span>
                      <GoogleReCaptcha
                        onVerify={setTokenFunc}
                        refreshReCaptcha={refreshReCaptcha}
                      />
                      <Button
                        type="submit"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {t("Login Text")}
                      </Button>
                    </Form>
                    <div className="google-link">
                      <h6>
                        {" "}
                        This site is protected by reCAPTCHA and the Google{" "}
                        <a href="https://policies.google.com/privacy">
                          Privacy Policy
                        </a>{" "}
                        and{" "}
                        <a href="https://policies.google.com/terms">
                          Terms of Service
                        </a>{" "}
                        apply.
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Modal>
      <OtpModal
        formData={formData}
        open={open}
        setOpen={setOpen}
        formValue={formValue}
        handleResendOtp={handleResendOtp}
        seconds={seconds}
        resendLoading={resendLoading}
        isResendDisable={isResendDisable}
      />
    </div>
  );
};
export default ExistingUserLogin;
